module.exports = __webpack_public_path__ + "static/Huawei_678x452-d82c2a44e88872209512304eed37c36a.png";